import { InjectionToken } from "@angular/core";
import type { IAccessibleTenantInfo, IMfaVerificationRequest, ISelectTenantRequest } from "@kiraah-shared/common";
import {
  LogoutRequest,
  MobileAuthResult,
  MobileLoginRequest,
  OtpLoginRequest,
  OtpLoginRequestResult,
  OtpLoginVerifyRequest,
  TokenPairInfo,
} from "../models/mobile-auth.models";

export interface IMobileAuthService {
  login(data: MobileLoginRequest): Promise<MobileAuthResult>;
  verifyMfa(data: IMfaVerificationRequest): Promise<MobileAuthResult>;
  selectTenant(data: ISelectTenantRequest): Promise<MobileAuthResult>;
  requestOtpLogin(data: OtpLoginRequest): Promise<OtpLoginRequestResult>;
  verifyOtpLogin(data: OtpLoginVerifyRequest): Promise<MobileAuthResult>;
  me(): Promise<MobileAuthResult>;
  getAccessibleTenants(): Promise<IAccessibleTenantInfo[]>;
  refreshToken(): Promise<TokenPairInfo>;
  logout(identityUid: string, request?: LogoutRequest): Promise<void>;
}

export const MOBILE_AUTH_SERVICE = new InjectionToken<IMobileAuthService>("MOBILE_AUTH_SERVICE");
